import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled, { css, mediaQuery, theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import PublicLanguageDropdown from '../../publicLanguage/components/PublicLanguageDropdown';
import UIBox from 'UIComponents/layout/UIBox';
import { Box } from 'foundations-components/transitional/components/Box';
import PublicSearch from '../../publicSearch/components/PublicSearch';
import PublicPageAuthButtons from './PublicPageAuthButtons';
import PublicPageThemeToggle from './PublicPageThemeToggle';
// @ts-expect-error Could not find a declaration file for module
import academyLogo from 'bender-url!../../../../images/hubspot-academy-logo-color.svg';
import { Image } from 'foundations-components/transitional/components/Image';
import PublicPageNavDropdown from './PublicPageNavDropdown';
import PublicPageNavLink from './PublicPageNavLink';
import PublicPageMobileNavMenu from './PublicPageMobileNavMenu';
import usageTracker from '../../../utils/usageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PrimaryNav = styled.nav.withConfig({
  displayName: "PublicPageNavigation__PrimaryNav",
  componentId: "sc-1q69kd1-0"
})(["background-color:", ";border-bottom:1px solid ", ";position:fixed;top:0;width:100%;min-height:", ";display:flex;justify-content:center;z-index:100;"], theme.colors.GYPSUM, theme.colors.GREAT_WHITE, theme.sizes.PUBLIC_NAV_FULL_HEIGHT);
const SecondaryNav = styled.nav.withConfig({
  displayName: "PublicPageNavigation__SecondaryNav",
  componentId: "sc-1q69kd1-1"
})(["position:fixed;top:", ";width:100%;min-height:", ";background-color:", ";display:flex;justify-content:center;z-index:99;", ""], theme.sizes.PUBLIC_NAV_FULL_HEIGHT, theme.sizes.PUBLIC_NAV_FULL_HEIGHT, theme.colors.OLAF, mediaQuery('mobile', css(["top:0;min-height:", ";"], theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT)));
const NavContents = styled.div.withConfig({
  displayName: "PublicPageNavigation__NavContents",
  componentId: "sc-1q69kd1-2"
})(["max-width:", ";width:100%;display:flex;align-items:center;position:relative;padding:0 12px;", ""], theme.sizes.PUBLIC_PAGE_WIDTH, mediaQuery('mobile', css(["justify-content:space-between;"])));

/**
 * Since the nav is `position: fixed` this is a way of spacing the content
 * below the nav down without having to embed nav height logic into the main
 * section component's margins
 */
const ContentSpacer = styled.div.withConfig({
  displayName: "PublicPageNavigation__ContentSpacer",
  componentId: "sc-1q69kd1-3"
})(["min-height:calc(", " * 2);", ""], theme.sizes.PUBLIC_NAV_FULL_HEIGHT, mediaQuery('mobile', css(["min-height:", ";"], theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT)));
const PublicPageNavigation = ({
  availableLanguages,
  languageLinkedContent,
  contentType,
  pagePath
}) => {
  const handleTrackNavItemClick = e => {
    var _e$currentTarget;
    usageTracker.track('navInteraction', {
      action: 'nav-item-click',
      // @ts-expect-error href is not a property of HTMLElement
      href: ((_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.href) || ''
    });
  };
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isMobile && /*#__PURE__*/_jsx(PrimaryNav, {
      children: /*#__PURE__*/_jsx(NavContents, {
        children: /*#__PURE__*/_jsxs(TFlex, {
          justify: "between",
          children: [/*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsxs(TFlex, {
              align: "center",
              children: [/*#__PURE__*/_jsx(Box, {
                marginInlineEnd: "200",
                children: /*#__PURE__*/_jsx(PublicLanguageDropdown, {
                  contentType: contentType,
                  languageLinkedContent: languageLinkedContent,
                  options: availableLanguages,
                  pagePath: pagePath
                })
              }), /*#__PURE__*/_jsx(Box, {
                children: /*#__PURE__*/_jsx(PublicPageThemeToggle, {})
              })]
            })
          }), /*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsxs(TFlex, {
              children: [/*#__PURE__*/_jsx(UIBox, {
                style: {
                  maxWidth: 365,
                  marginRight: 12
                },
                children: /*#__PURE__*/_jsx(PublicSearch, {})
              }), /*#__PURE__*/_jsx(Box, {
                children: /*#__PURE__*/_jsx(PublicPageAuthButtons, {})
              })]
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(SecondaryNav, {
      children: /*#__PURE__*/_jsxs(NavContents, {
        children: [/*#__PURE__*/_jsx(UIRouterLink, {
          "aria-label": I18n.text('academyPublic.publicNav.hubspotAcademyLogo'),
          className: "m-right-8",
          onClick: handleTrackNavItemClick,
          to: '/',
          children: /*#__PURE__*/_jsx(Image, {
            height: 28,
            src: academyLogo,
            width: 200
          })
        }), !isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PublicPageNavDropdown, {}), /*#__PURE__*/_jsx(PublicPageNavLink, {
            href: getProxyUrl('what-is-hubspot-academy'),
            onClick: handleTrackNavItemClick,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.about"
            })
          })]
        }) : /*#__PURE__*/_jsx(PublicPageMobileNavMenu, {
          availableLanguages: availableLanguages,
          contentType: contentType,
          languageLinkedContent: languageLinkedContent,
          pagePath: pagePath
        })]
      })
    }), /*#__PURE__*/_jsx(ContentSpacer, {})]
  });
};
export default PublicPageNavigation;